import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import ChartComponent from "../Highcharts/ChartComponent";
import { reportBarConfig } from "../Highcharts/chartconfig";
import axios from "axios";
import Loader from "./Loader";

function CountiesCases({ requestData }) {
  const [chartCounter, setChartCounter] = useState(null);

  useEffect(() => {
    let requestBody = {
      communityId: "fee5c0c217af285485abb2e583cb806c",
      userIdentifier: "County",
    };
    if (Object.keys(requestData).length > 0) {
      let oRequest = { ...requestBody, ...requestData };
      if (
        (requestData?.globalFilters?.dateFilter.to !== "" &&
          requestData?.globalFilters?.dateFilter.from !== "") ||
        (requestData.questionIds != null &&
          requestData.selectedOption != null) ||
        (requestData.subQuestionIds != null &&
          requestData.selectedOption != null) ||
        requestData.serviceIdFilter != null
      ) {
        getCountiesData(oRequest);
      }
    } else {
      getCountiesData(requestBody);
    }
  }, [requestData]);

  let getCountiesData = async (data) => {
    try {
      let res = await axios.post(
        `${process.env.REACT_APP_API_KEY}/opendashboard/countiesOrUserTypeReportingCases `,
        data
      );
      let formatedData = res.data.data;
      let sortedArray = Object.entries(formatedData)
      .sort((a, b) => b[1] - a[1]);
  
      let sortedFormatedData = Object.fromEntries(sortedArray);
      let catagoriesArr = Object.keys(sortedFormatedData).slice(0, 10);
      let chartValues = Object.values(formatedData).slice(0, 10);
      let percentValues = [];

      Object.keys(formatedData)
        .slice(0, 10)
        .forEach((key, index) => {
          let percentVal;
          if (sortedFormatedData[key] !== 0 && totalValue(sortedFormatedData) !== 0) {
            percentVal = Math.round(
              (sortedFormatedData[key] / totalValue(sortedFormatedData)) * 100
            );
          } else {
            percentVal = 0;
          }
          let obj = {
            percent: percentVal,
            y: sortedFormatedData[key],
          };
          percentValues = [...percentValues, obj];
        });

      let obj = {
        catagoriesArr,
        percentValues,
      };
      setChartCounter(obj);
    } catch (error) {
      console.log(error);
    }
  };

  const totalValue = (data) => {
    let values = Object.values(data);
    const sumWithIndictors = values.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    );
    return sumWithIndictors;
  };

  return (
    <Card>
      <Card.Body className="pb-3">
        <h5>Top 10 counties reporting cases</h5>
        {chartCounter !== null ? (
          <ChartComponent options={reportBarConfig(chartCounter)} />
        ) : (
          <Loader />
        )}
      </Card.Body>
    </Card>
  );
}

export default CountiesCases;
